<template>
  <div class="main-content-container container-fluid px-2 px-sm-4 bgcontainer">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-2 py-sm-3">
      <div class="col-12 text-center text-sm-left mb-0">
        <p class="mb-0  text-center text-title">Fichaje:</p>
      </div>
    </div>
    <div class="container px-0">
      <p class="mb-0 mb-sm-2 text-center">{{ dataContrato.direccion1 }}</p>
      <div class="text-center">
        <span style="font-size:12px !important; margin:0px !important;padding:0px !important">
          {{ 'coordenadas contra: ' + (contrato && contrato.google ? contrato.google : '') }}
        </span><br />
        <span style="font-size:12px !important; margin:0px !important;padding:0px !important">
          {{ 'mis coordenadas: ' + misCoordenadas }}
        </span>
      </div>
      <div>
        <!-- ✅ Mensaje de error PERSISTENTE -->
        <div v-if="message" class="info alert-success mb-3 text-center text-black"
          style="font-size: 0.85rem; padding: 0.5rem;">
          {{ message }}
        </div>
        <div v-if="error" class="alert alert-danger mb-3 text-center"
          style="font-size: 0.85rem; padding: 0.5rem;">
          {{ error }}
        </div>
        <div v-if="message2" class="alert alert-warning mb-3 text-center text-black"
          style="font-size: 0.85rem; padding: 0.5rem;">
          {{ message2 }}
        </div>
      </div>
{{ flexible_coordenadas }}
      <div class="row mt-0">
        <div class="col-12 col-md-8 offset-md-2">
          <form>
            <div class="form-group row mb-0 mb-sm-2">
              <label for="horario" class="col-12 col-sm-3 col-form-label">Contrato:</label>
              <div class="col-12 col-sm-9">
                <input type="text" readonly class="form-control" id="horario" v-model="dataContrato.contrato_id">
              </div>
            </div>
            <div class="form-group row mb-0 mb-sm-2">
              <label for="dias" class="col-12 col-sm-3 col-form-label">Entrada</label>
              <div class="col-12 col-sm-9">
                <input type="text" readonly class="form-control" id="dias" v-model="dataContrato.entrada">
              </div>
            </div>
            <div class="form-group row mb-0 mb-sm-2">
              <label for="categoria" class="col-12 col-sm-3 col-form-label">Salida:</label>
              <div class="col-12 col-sm-9">
                <input type="text" readonly class="form-control" id="categoria" v-model="dataContrato.salida">
              </div>
            </div>
            <div class="form-group row mb-0 mb-sm-3 m-2">
              <div class="col-12 col-sm-9 d-flex align-items-center form-check form-check-inline">
                <label for="materiales" class="form-check-label">Materiales:</label>
                <input class="form-check-input" type="checkbox" id="materiales" v-model="dataContrato.materiales">
              </div>
            </div>


            <!-- ✅ Botón "Verificar mi ubicación" (igual que en Home) -->
            <div v-if="!flexible_coordenadas && !ubicacionVerificada"
              class="d-flex flex-column flex-sm-row justify-content-center gap-1 gap-sm-2 mb-2 mb-sm-3">
              <button type="button" @click="requestPermissionManually" :disabled="verificandoUbicacion"
                class="btn-accent w-100 w-sm-auto">
                {{ verificandoUbicacion ? 'Verificando...' : 'Verificar mi ubicación' }}
              </button>
            </div>

            <!-- ✅ Botones de fichaje -->
            
            <div v-else class="d-flex flex-column flex-sm-row justify-content-center gap-1 gap-sm-2 mb-2 mb-sm-3">
              <d-button v-if="dataContrato.entrada == '--'" :disabled="bloqueoBoton" type="button"
                @click="nuevoFichado('Entrada')" class="btn-accent">
                FICHAR ENTRADA
              </d-button>
              <d-button v-if="dataContrato.entrada != '--' && dataContrato.salida == '--'" :disabled="bloqueoBoton"
                type="button" @click="nuevoFichado('Salida')" class="btn-accent">
                FICHAR SALIDA
              </d-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../config/api";

export default {
  name: "Fichaje",
  data() {
    return {
      dataContrato: {
        direccion1: '',
        contrato_id: 0,
        entrada: '',
        salida: '',
        comentario: '',
        materiales: false
      },
      contrato: null,
      user: null,
      misCoordenadas: '',
      flexible_coordenadas: false,
      ubicacionVerificada: false,
      verificandoUbicacion: false,
      error: null,
      message: null,
      message2: null,
      bloqueoBoton: false,
      distancia: 0,
      expe: '',
      countdown: 8,
      interval: null
    };
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user')) || {};
    this.contrato = JSON.parse(localStorage.getItem('controdata')) || {};

    this.dataContrato.contrato_id = this.contrato.contro_id;
    this.dataContrato.direccion1 = this.contrato.direccion1;
    this.flexible_coordenadas = this.contrato.flexible_coordenadas || false;

    this.$isLoading(true);
    await this.getFichajeContra();
    this.$isLoading(false);

    // ✅ Verificación inicial (igual que en Home.vue)
    if (!this.flexible_coordenadas) {
      this.checkGeolocationSupport();
    } else {
      this.ubicacionVerificada = true;
    }
  },
  methods: {
    updateMessage() {
      this.message2 = `REGRESANDO AL MENU PRINCIPAL EN  ${this.countdown} SEGUNDOS...`;
    },
    beforeDestroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },

    // ✅ Método idéntico al de Home.vue
    checkGeolocationSupport() {
      if (!navigator.geolocation) {
        this.error = "Tu navegador no soporta geolocalización.";
        this.ubicacionVerificada = false;
        return;
      }

      if (navigator.permissions && navigator.permissions.query) {
        this.checkPermissionState();
      } else {
        this.getLocation();
      }
    },

    async checkPermissionState() {
      try {
        const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
        this.handlePermissionState(permissionStatus.state);
        permissionStatus.onchange = () => {
          this.handlePermissionState(permissionStatus.state);
        };
      } catch (error) {
        console.warn("Permissions API no disponible, usando fallback");
        this.getLocation();
      }
    },

    handlePermissionState(state) {
      switch (state) {
        case "granted":
          this.getLocation();
          break;
        case "prompt":
          this.getLocation();
          break;
        case "denied":
          this.error = "Has denegado el acceso a tu ubicación. Por favor, permite el acceso desde la configuración de tu navegador.";
          this.ubicacionVerificada = false;
          break;
        default:
          this.getLocation();
      }
    },

    getLocation() {
      this.verificandoUbicacion = true;
      this.error = null;

      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.misCoordenadas = `${position.coords.latitude}, ${position.coords.longitude}`;
          this.ubicacionVerificada = true;
          this.verificandoUbicacion = false;
          this.error = null;
        },
        (error) => {
          this.ubicacionVerificada = false;
          this.verificandoUbicacion = false;
          let errorMsg = "No se pudo obtener tu ubicación.";
          if (error.code === error.PERMISSION_DENIED) {
            errorMsg = "Permiso de ubicación denegado. Por favor, permite el acceso a tu ubicación.";
          } else if (error.code === error.POSITION_UNAVAILABLE) {
            errorMsg = "Ubicación no disponible.";
          } else if (error.code === error.TIMEOUT) {
            errorMsg = "Tiempo de espera agotado.";
          }
          this.error = errorMsg;
        },
        options
      );
    },

    // ✅ Botón "Verificar mi ubicación" llama al mismo flujo que en Home
    requestPermissionManually() {
      this.getLocation();
    },

    rad(x) {
      return x * Math.PI / 180;
    },

    async getKilometros(lat1, lon1, lat2, lon2) {
      const R = 6378.137;
      const dLat = this.rad(lat2 - lat1);
      const dLong = this.rad(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.rad(lat1)) * Math.cos(this.rad(lat2)) *
        Math.sin(dLong / 2) * Math.sin(dLong / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c * 1000;
      return d.toFixed(3);
    },

    async getFichajeContra() {
      try {
        const data = {
          contra_id: this.contrato.contra_id,
          contro_id: this.dataContrato.contrato_id,
          usuario_id: 'WB2',
          numero: this.user.numero
        };
        const result = await api.request("post", '/verificafichajeContra', data);
        console.log('verificafichajeContra-->', result.data)
        this.dataContrato.comentario = (!result.data.justifica || (result.data.justifica === null || result.data.justifica === 'undefined')) ? '' : result.data.justifica;
        this.dataContrato.materiales = result.data.materiales === '1';

        if (result.data.id_diario) {
          if (!result.data.fecha_salida || result.data.fecha_salida === 'null' || result.data.fecha_salida === null) {
            const fechaEntrada = result.data.fecha_entrada;
            this.dataContrato.entrada = (fechaEntrada && typeof fechaEntrada === 'string')
              ? fechaEntrada.substr(11, 8)
              : '--';
            this.dataContrato.salida = '--';
          } else {
            this.dataContrato.entrada = '--';
            this.dataContrato.salida = '--';
          }
        } else {
          this.dataContrato.entrada = '--';
          this.dataContrato.salida = '--';
        }
      } catch (error) {
        console.error("Error en getFichajeContra:", error);
        this.dataContrato.entrada = '--';
        this.dataContrato.salida = '--';
      }
    },

    async nuevoFichado(tipo) {
      // ✅ Verificar que la ubicación esté lista (igual que en Home)
      if (!this.flexible_coordenadas && !this.ubicacionVerificada) {
        return;
      }

      this.bloqueoBoton = true;

      try {
        const coords = this.misCoordenadas.split(',');
        const latitud = parseFloat(coords[0]);
        const longitud = parseFloat(coords[1]);

        const coordenadasContra = (this.contrato.google || '').split(",");
        if (coordenadasContra.length < 2) {
          this.error = "Error, contrata sin coordenadas.";
          this.bloqueoBoton = false;
          return;
        }

        const lt = coordenadasContra[0].replace(/'/g, '').trim();
        const lng = coordenadasContra[1].replace(/'/g, '').trim();

        this.distancia = await this.getKilometros(latitud, longitud, parseFloat(lt), parseFloat(lng));

        let informacion = '';
        let calculoCoordenadas = false;
        console.log(this.contrato.flexible_total)
        console.log(this.contrato.flexible_coordenadas)
        if (this.contrato.flexible_total === 1 || this.contrato.flexible_coordenadas === 1) {
          calculoCoordenadas = true;
          informacion = (this.contrato.flexible_total === 1 ? 'flexible total.' : 'flexible coordenadas.') +
            ' / Su distancia es: ' + this.distancia + " mts." + this.expe;
        } else {
          if (!this.contrato.google || this.contrato.google.trim() === '') {
            this.error = "Error, contrata sin coordenadas.";
            this.bloqueoBoton = false;
            return;
          }

          if (parseFloat(this.distancia) > 800) {
            this.error = "Error, no está en el rango permitido.";
            this.bloqueoBoton = false;
            return;
          }

          informacion = 'Está en el rango para marcar, su distancia es: ' + this.distancia + " mts." + this.expe;
          calculoCoordenadas = true;
        }

        if (calculoCoordenadas) {
          const horario = this.contrato.horario;
          const horariotmp1 = horario.substr(0, 2);
          const horariotmp2 = horario.substr(2, 2);
          const horarioFormatted = horariotmp1 + ":" + horariotmp2;
          const diassemana = this.contrato.diassemana && this.contrato.diassemana.length > 0
            ? this.contrato.diassemana[0].trim()
            : '';
          const horasdia = this.contrato.horas_dia;

          const datav = {
            dias: diassemana,
            horariotmp: horarioFormatted,
            horasdia: horasdia,
            contra_id: this.contrato.contra_id,
            contro_id: this.contrato.contro_id,
            numero: this.user.numero,
            informacion: informacion,
            justifica: this.dataContrato.comentario || '',
            ubicacion: `${latitud}, ${longitud}`,
            expe: this.expe,
            usuario_id: 'WB2',
            flexible_total: this.contrato.flexible_total,
            materiales: this.dataContrato.materiales ? '1' : '0'
          };

          this.$isLoading(true);
          let respu = await api.request("post", "/nuevoFichajeApp/", datav); //<--- revisar obtener mensaje
          
          console.log('resultado nuevofichajeapp--->', respu)
          
          await this.getFichajeContra();
          this.error = ""
          this.message = "✅ Has fichado ENTRADA correctamente.";
          this.$isLoading(false);

          if (tipo === 'Salida') {
            this.message = "✅ Has fichado SALIDA correctamente.";
            this.error = ""

            this.updateMessage();
            this.interval = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.interval);
                // Redirigir al menú principal
                // this.$router.push('/'); // Ajusta la ruta si tu menú está en otra
                this.$router.push('/admin/home');

              } else {
                this.updateMessage();
              }
            }, 1000);

          }
        }
      } catch (error) {
        console.error("Error en nuevoFichado:", error);
        this.message = ""
        this.error = "Error, inténtalo nuevamente. " + error;
        this.$isLoading(false);

      } finally {
        this.bloqueoBoton = false;
      }
    }
  }
};
</script>

<style scoped>
/* ... (mismos estilos que antes) ... */
.text-black {
  color: black !important;
  font-weight: bold !important;
}
.text-title{
  font-size: 22px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif !important;
}
</style>